var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.updateCardKey, staticClass: "company" },
    [
      !_vm.selectedCompany
        ? _c("div", { staticClass: "no company-card" }, [
            _c("span", [_vm._v("Please select a company")])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedCompany
        ? _c(
            "div",
            { staticClass: "company-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.cardObjectIdentifier,
                  "identifier-label": _vm.$t("Name"),
                  "editing-data": _vm.editingData,
                  "show-edit-button":
                    !_vm.creatingCompany &&
                    ((_vm.userHasPermission("company_update") &&
                      !_vm.companyIsParentCompany) ||
                      _vm.isSuperAdmin),
                  "card-label": _vm.showPermissions
                    ? _vm.$tc("Permission", 2) + ": " + _vm.company.name
                    : _vm.cardLabel,
                  height: _vm.cardHeight,
                  "expand-card": _vm.editingData || _vm.showPermissions,
                  "submit-button-label": _vm.submitButtonLabel,
                  "required-fields-filled": _vm.requiredFieldsAreFilled,
                  showEditActionButtons: ""
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "save-object": _vm.saveObject,
                  "update-object": _vm.updateCompany,
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  }
                },
                scopedSlots: _vm._u(
                  [
                    !_vm.showPermissions
                      ? {
                          key: "object-image-slot",
                          fn: function() {
                            return [
                              _c("img", {
                                staticClass: "company-logo",
                                attrs: {
                                  src: _vm.company ? _vm.company.image : null,
                                  alt: "Company Image Icon"
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      : null,
                    !_vm.showPermissions && !_vm.companyIsParentCompany
                      ? {
                          key: "buttons-before-edit-slot",
                          fn: function() {
                            return [
                              _c("custom-button", {
                                attrs: {
                                  icon: "mdi-key",
                                  "icon-size": 13,
                                  height: "20px",
                                  width: "20px",
                                  "button-styling": _vm.buttonStyling,
                                  disabled: _vm.company
                                    ? !_vm.company.company_id &&
                                      !_vm.companyIsParentCompany
                                    : true
                                },
                                on: { buttonClick: _vm.togglePermissions }
                              })
                            ]
                          },
                          proxy: true
                        }
                      : null,
                    _vm.editingData && !_vm.showPermissions
                      ? {
                          key: "before-fields-slot",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "edit-image-container" },
                                [
                                  _c("input", {
                                    ref: "file",
                                    staticStyle: { display: "none" },
                                    attrs: {
                                      type: "file",
                                      id: "file",
                                      accept: "image/*"
                                    },
                                    on: { change: _vm.previewFile }
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticClass: "company-logo",
                                    attrs: {
                                      src: _vm.company
                                        ? _vm.company.image
                                        : null,
                                      alt: "Company Image Icon"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("custom-button", {
                                    attrs: {
                                      height: "20px",
                                      label: !_vm.creatingCompany
                                        ? _vm.$t("ChangePhoto")
                                        : _vm.$t("AddPhoto"),
                                      "button-styling": Object.assign(
                                        {},
                                        _vm.buttonStyling,
                                        {
                                          padding: "0 5px",
                                          "margin-right": "7px",
                                          "font-size": "9px"
                                        }
                                      )
                                    },
                                    on: { buttonClick: _vm.submitFile }
                                  }),
                                  _vm._v(" "),
                                  _c("custom-button", {
                                    attrs: {
                                      icon: "mdi-delete",
                                      "icon-size": 13,
                                      width: "20px",
                                      height: "20px",
                                      "button-styling": _vm.buttonStyling
                                    },
                                    on: { buttonClick: _vm.deleteCompanyImage }
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      : _vm.showPermissions
                      ? {
                          key: "before-fields-slot",
                          fn: function() {
                            return [
                              _c(
                                "div",
                                { staticClass: "permissionMatrixDiv" },
                                [
                                  _c("permission-matrix", {
                                    attrs: {
                                      data: _vm.permissionsMatrix,
                                      disabled: !_vm.editingData
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          },
                          proxy: true
                        }
                      : null,
                    _vm.showPermissions
                      ? {
                          key: "before-title-slot",
                          fn: function() {
                            return [
                              _c("custom-button", {
                                attrs: {
                                  icon: "mdi-chevron-left",
                                  "icon-size": 14,
                                  height: "16px",
                                  width: "16px",
                                  "button-styling": Object.assign(
                                    {},
                                    _vm.buttonStyling,
                                    { "box-shadow": "none" }
                                  ),
                                  "button-color": "transparent",
                                  "icon-color": "var(--app-primary-base)"
                                },
                                on: { buttonClick: _vm.togglePermissions }
                              })
                            ]
                          },
                          proxy: true
                        }
                      : null
                  ],
                  null,
                  true
                )
              }),
              _vm._v(" "),
              !_vm.editingData && !_vm.showPermissions
                ? _c("company-specific-info", {
                    attrs: {
                      users: _vm.company ? _vm.company.users : [],
                      roles: _vm.company ? _vm.company.roles : [],
                      workspaces: _vm.company ? _vm.company.workspaces : []
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d83c744", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d83c744","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/SystemManagement/Companies/Company.vue
// module id = null
// module chunks = 